



import React, { useEffect, useContext, useState } from 'react';
import { Flex, Row, message, Upload, Dialo, Tabs } from 'antd';
import FormRender, { useForm } from 'form-render';
import { Dialog,  } from 'antd-mobile';
import { FormConfigProvider, FormConfigContext } from './provider';
import { PlusOutlined } from '@ant-design/icons';
import can from '../../../../components/ability';


export default (props) => {
    
    const { value, onChange, addons } = props;
    const globalConfig = useContext(FormConfigContext);
    const [theV, setTheV] = useState([]);
    const imageUrlPrefix = '//img.yxdj.tech/';

    useEffect(() => {
        if (value) {
            setTheV([{
                url: value,
                thumbUrl: `${imageUrlPrefix}${value}?x-oss-process=image/resize,w_200`, name: '', type: "image/jpeg"
            }])
        }
    }, [value]);

    const beforeUpload = async (file) => {
        // console.log('beforeUpload', file);
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('请上传JPG/PNG图片!');
        }
        const isLt8M = file.size / 1024 / 1024 < 8;
        if (!isLt8M) {
            message.error('图片必须小于 8MB!');
        }
        // console.log('upload', file);

        return isJpgOrPng && isLt8M;
    };

    const handleChange = ({file, fileList}) => {
        // console.log(file.status, fieldName, file, fileList);
        if(file.status === undefined) return false;

        if(file.status === 'done') {
            let thumbUrl = file.response.data.url.replace('http://weijia-hz-pub.oss-cn-hangzhou.aliyuncs.com', 'https://img.yxdj.tech');
            let imgUrl = file.response.data.url.replace('http://weijia-hz-pub.oss-cn-hangzhou.aliyuncs.com/', '');

            fileList = fileList.map((item) => {

                if(file.uid === item.uid) {
                    return { uid: item.uid, type: item.type, thumbUrl: thumbUrl + '?x-oss-process=image/resize,w_200', url: imgUrl }
                } else {
                    return item
                }
            });
            onChange(fileList[0]['url'])
        }
        if (!fileList || fileList.length <= 0) {
            onChange(undefined);
        }
        setTheV([...fileList]);
    };
    const uploadButton = (
        <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>上传图片</div>
        </button>
    );
    return (
        <div className='comp-form-customer-field'>
            <Upload
                // name="avatar"
                // defaultFileList={mainImages}
                fileList={theV}
                listType="picture-card"
                maxCount={1}
                action="/api/upload/image"
                beforeUpload={beforeUpload}
                onChange={(file) => handleChange(file)}
            >
                {uploadButton}
            </Upload>
        </div>
    );
};